import { EventPanelConfiguration, EventPanelFormType } from '@mark43/cad-api';

type EventPanelFormTypePersonDto = EventPanelFormType['involvedPersons'][0];

export function getDefaultPerson(
    eventPanelConfig?: EventPanelConfiguration
): EventPanelFormTypePersonDto {
    return {
        dateOfBirth: null,
        ageMax: null,
        ageMin: null,
        driversLicenseNumber: null,
        driversLicenseState: null,
        eyeColor: null,
        firstName: null,
        hairColor: null,
        involvementTypeOption: null,
        involvementTypeOther: null,
        isDateOfBirthUnknown: false,
        lastName: null,
        location: null,
        locationSubPremise: null,
        middleName: null,
        notes: null,
        phoneExtension: null,
        phoneNumber: null,
        purposeCode: eventPanelConfig?.defaultPurposeCode ?? null,
        queryInDex: false,
        race: null,
        sex: null,
        imageIndicator: eventPanelConfig?.defaultImageIndicator ?? null,
        contextId: null,
        eventInfo: null,
        personProfileId: null,
        isRemoved: false,
        isPersisted: false,
        fullName: null,
        locationDisplay: null,
        height: null,
        heightMin: null,
        heightMax: null,
        weight: null,
        weightMax: null,
        weightMin: null,
        isPrimary: false,
        eventMasterPersonData: null,
        socialSecurityNumber: '',
        address: null,
        addressSubPremise: null,
        addressDisplay: null,
    };
}
